import MessageCommon from 'epic-localization/src/client/message/Message';
import {mapStateToProps} from 'epic-localization/src/client/reducers/localization.reducer';

const reducerName = 'localization';
export default MessageCommon(reducerName);
export const mapMessageStateToProps = mapStateToProps(reducerName);

export {selectMessages} from 'epic-localization/src/client/reducers/localization.reducer';
export {getMessage} from 'epic-localization/src/client/message/Message';
